import { useEffect, useState, type ReactNode } from 'react';
import { ButterflyLoading, ButterflyStatusScreen } from './status-views';
import { ShieldCheck } from 'lucide-react';
import './butterfly-world.css';

export function ButterflyAdminGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<'loading' | 'allowed' | 'denied'>('loading');
  useEffect(() => {
    const abort = new AbortController();
    fetch('/api/admin/auth/user', { credentials: 'same-origin', cache: 'no-store', signal: abort.signal })
      .then(async (response) => response.ok && Boolean((await response.json()).masterKey))
      .then((allowed) => { if (!abort.signal.aborted) setState(allowed ? 'allowed' : 'denied'); })
      .catch(() => { if (!abort.signal.aborted) setState('denied'); });
    return () => abort.abort();
  }, []);
  if (state === 'loading') return <ButterflyLoading />;
  if (state === 'denied') return <ButterflyStatusScreen icon={<ShieldCheck size={28} />} eyebrow="Скоро здесь станет оживлённо" title="Закрытое тестирование"
    actions={<a className="world-button world-button--primary" href="/admin/login" target="_blank" rel="noreferrer">Войти в админку</a>}>
    <p>«Ожившие бабочки» пока доступны только администратору.</p>
    <p className="butterfly-status__hint">После входа обновите эту страницу. Гостям по QR вход не нужен.</p>
  </ButterflyStatusScreen>;
  return <>{children}</>;
}
